<template>
  <div class="eChart__detail" id="chartDetail"></div>
</template>

<script>
import { mapState } from "vuex";
const echarts = require("echarts");

export default {
  data() {
    return {
      isLoadingData: null,
      listDataDetailsShowDialog: null,
      indicator: [],
      score: [],
    };
  },

  props: {
    data: Object
  },

  computed: {
    // get data from store
    ...mapState({
      mobile: (state) => state.header.mobile,
    }),
  },

  created() {
    this.init();
  },

  methods: {
    async init () {
      const listDataDetail       = await this.getScoreRate();
      const listDataDetailDialog = listDataDetail.filter((x) => x.maxScore != null);

      this.getDataForChart(listDataDetailDialog);

      this.drawChart(this.indicator, this.score);
    },

    getDataForChart (listData) {
      listData.forEach((item) => {
        this.indicator.push({ name: item.chapterName, max: item.maxScore });
        this.score.push(item.score);
      });
    },

    getScoreRate () {
      return new Promise((resolve, reject) => {
        this.$api
            .post("/courseStudy/getScoreRate", {
              examId    : this.data.examId    || null,
              courseId  : this.data.courseId  || null,
              id        : this.data.recordId  || null,
              studentId : this.data.studentId || null,
            }).then((response) => {
              resolve(response.data);
            }).catch(() => {});
      })
    },

    drawChart (chartIndicator, chartScore) {
      const el     = document.getElementById("chartDetail");
      const canvas = document.createElement("canvas");
      const div    = document.createElement("div");
      if (typeof G_vmlCanvasManager !== "undefined") {
        G_vmlCanvasManager.initElement(canvas);
      }
      div.style.width  = "100%";
      div.style.height = "400px";
      el.appendChild(div);
      const option = {
        legend: {
          data: [this.$t("detailExam.totalScore")],
          selectorLabel: {
            backgroundColor: "rgba(145, 204, 117, 1)",
          },
        },
        tooltip: {
          trigger: 'item'
        },
        radar: {
          shape: "circle",
          radius: "70%",
          name: {
            textStyle: {
              color: "#fff",
              backgroundColor: "rgba(84, 112, 198, 1)",
              borderRadius: 3,
              padding: [3, 5],
            },
          },
          splitNumber: 4,
          splitArea: {
            areaStyle: {
              color: ["#77EADF", "#26C3BE", "#64AFE9", "#428BD4"],
            },
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowBlur: 10,
          },
          axisTick: {
            show: true,
            length: 10,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.8)",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#6D214F",
            },
          },
          axisLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.4)",
            },
            symbol: "none",
          },
          splitLine: {
            lineStyle: {
              color: "rgba(255, 255, 255, 0.4)",
            },
          },
          indicator: chartIndicator,
        },
        series: [
          {
            name: "Detail Chart",
            type: "radar",
            emphasis: {
              lineStyle: {
                width: 4,
              },
            },
            data: [
              {
                value: chartScore,
                name: this.$t("detailExam.totalScore"),
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: "rgba(255, 145, 124, 0.1)",
                      offset: 0,
                    },
                    {
                      color: "rgba(255, 145, 124, 0.9)",
                      offset: 1,
                    },
                  ]),
                },
                symbolSize: 10,
              },
            ],
          },
        ],
      };
      const mediaQuery = [
        {
          query: {
            maxWidth: 1024,
          },
          option: {
            title: {
              show: false,
            },
          },
        },
      ];
      //init
      echarts.init(div).setOption({ baseOption: option, media: mediaQuery });
    }
  },
};
</script>
<style scoped>
@media (max-width: 768px) {
  .eChart__detail {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/exam/chartDetailExam.vue